import script from "./FiltroAtividade.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroAtividade.vue?vue&type=script&setup=true&lang=js"

import "./FiltroAtividade.vue?vue&type=style&index=0&id=1b269bf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b269bf1"]])

export default __exports__